import React from 'react'
import { Divider } from 'antd'
import * as styles from './index.scss'

interface Props {
  title: string | JSX.Element
  description?: string
  loading?: boolean
  style?: React.CSSProperties
  dark?: boolean
  star?: { url: string; count: number }
}
const Hero: React.SFC<Props> = ({
  children,
  title,
  description,
  loading,
  style,
  dark,
  star = { url: '', count: 0 },
}) => {
  return (
    <section className={styles.hero} style={style}>
      <div className={styles.heroInner}>
        <div className={styles.heroHeader}>
          <div
            className={styles.heroHeaderTitle}
            style={{
              color: dark && '#fff',
            }}
          >
            <div>{title}</div>
          </div>
          {/* <div
            className={styles.heroHeaderDescription}
            style={{
              color: dark && '#fff',
            }}
          >
            <span>{description}</span>
          </div> */}
          <div className={styles.heroStars}>
            {!!star.count &&
              Array(star.count)
                .fill(undefined)
                .map((_, i) => (
                  <img key={`star${i}`} src={star.url} alt="star" />
                ))}
          </div>
        </div>
        <div className={styles.heroBody}>
          {loading ? (
            <div className={styles.nodata}>努力加载中...</div>
          ) : [].concat(children).length ? (
            children
          ) : (
            <div className={styles.nodata}>暂时什么都没有喔</div>
          )}
        </div>
      </div>
      {!dark && <Divider style={{ maxWidth: 1200, margin: '0 auto' }} />}
    </section>
  )
}

export default Hero
